<template>
  <div class="rootContainer">
    <searchBar class="searchBar" searchType="14" @search="onSearch"></searchBar>

    <div ref="topBarDom" class="top-bar-container">
      <filterMenu
        title="动作"
        displayName="title"
        v-model="motion"
        :filtersContent="motionFlags"
        :openShowMoreBtn="true"
        @selectChanged="filterChanged"
        :class="['no-scroll']"
      ></filterMenu>

      <div>
        <filterMenu
          title="分类"
          displayName="name"
          v-model="category"
          :filtersContent="categorys"
          :openShowMoreBtn="true"
          @selectChanged="filterChanged"
        ></filterMenu>
      </div>

      <div class="fixed-filter-container">
        <div>
          <filterMenu
            title="排序"
            displayName="name"
            v-model="sort"
            :filtersContent="sortFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="价格"
            displayName="name"
            v-model="price"
            :filtersContent="resourceLevelOptions"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="授权"
            displayName="name"
            v-model="commerical"
            :filtersContent="commericalFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <styleMenu
          class="style-layout"
          v-model="currentStyle"
          :menuList="StyleArrayMsg"
          @selectChange="onStyleChange"
        ></styleMenu>
      </div>
    </div>

    <div
      class="content-container"
      ref="contentcontainer"
      @scroll="handleScroll"
    >
      <ul class="content-list">
        <li
          v-for="(item, index) in contentList"
          :key="index"
          @mouseenter="startPreviewItem(item, index)"
          @mouseleave="stopPreviewItem()"
        >
          <div class="content-list-li-layout" @click="addToCanvas(item)">
            <div class="bg">
              <!-- 封面-->
              <img
                class="static-cover"
                :src="$handleAssetsUrl(item.thumbnailUrl)"
              />

              <!-- lottie -->
              <div :ref="'lottie' + index" class="lottie-cover"></div>

              <div class="logo-container">
                <div
                  v-show="item.CHARACTER.isCommerical"
                  class="commerical-logo"
                ></div>
              </div>

              <!-- <div class="addbtn" @click="addToCanvas(item)" @click.stop>添加到画布</div> -->
              <!-- <div
                v-if="
                  UserMsg.payForMaterial != 1 && item.CHARACTER.payType == 4
                "
                class="vip-logo"
              ></div>
              <div
                v-if="UserMsg.payForMaterial != 1 && item.CHARACTER.tt"
                class="price-style"
              >
                已购买
              </div> -->
              <payType-subscript
                :item="item.CHARACTER"
                style="right: 4px; bottom: 4px;position:absolute"
              ></payType-subscript>
              <div class="favorites-bg" @click="favoriteItem(item)" @click.stop>
                <div
                  class="favorites-state"
                  :class="[
                    item && item.CHARACTER.favorites
                      ? 'already-favorites'
                      : 'no-favorites',
                  ]"
                ></div>
              </div>
            </div>
            <span class="action-name">{{ getTitle(item) }}</span>
          </div>
        </li>
      </ul>
      <div class="loading">
        <Loading
          :loading="loadingStatus == 1"
          v-show="loadingStatus == 1"
        ></Loading>
        <div v-show="loadingStatus == 2">没有更多内容了哦</div>
      </div>
    </div>

    <isEmptyResult
      v-if="loadingStatus == 2 && contentList.length == 0"
    ></isEmptyResult>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchBar from "../searchBar";
import styleMenu from "../dropDownMenu";
import filterMenu from "../filterMenu";
import isEmptyResult from "../isEmptyResult";
import baseContent from "./baseContent.vue";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import Loading from "@/components/emodal/templateLib/loading";

export default {
  mixins: [baseContent],
  name: "rolesContent",
  data() {
    return {
      type: 14,
      //条件筛选
      motion: null,

      motionFlags: [{ title: "全部", flag: "all" }],

      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        // { name: "付费", value: "&payType=1" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],

      previewTimer: null,
      lottiedata: null, // 播放lottie
    };
  },
  props: {},
  components: {
    searchBar,
    styleMenu,
    filterMenu,
    isEmptyResult,
    PayTypeSubscript,
    Loading,
  },
  methods: {
    getTitle (item) {
      let c = item.CHARACTER.title.replace(/_.*$/, '');
      let a = item.title;
      return c ? `${c}-${a}` : a;
    },
    getCharacterAction: function () {
      this.motionFlags = [{ title: "全部", flag: "all" }];
      this.motion = this.motionFlags[0];
      this.$http
        .get("/api/common/material/getCharacterActionName")
        .then((res) => {
          //console.log(JSON.stringify(res.data.data));
          if (res.data.code == 200) {
            // this.motionFlags = res.data.data;
            for (const key in res.data.data) {
              if (this.motionFlags.length < 36) {
                this.motionFlags.push(res.data.data[key]);
              }
            }
          }
        })
        .catch((res) => {});
    },
    getContentList: function () {
      this.loadingStatus = 1;
      let url =
        "/api/common/material/findCharacterActionByName?fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex;

      //let isSingleClassifySearch = false;
      if (this.motion && this.motion.title != "全部") {
        url += "&name=" + this.motion.title;
      }
      if (this.category && this.category.id) {
        url += "&category=" + this.category.id;
        //isSingleClassifySearch = true;
      }
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      if (this.sort) {
        url += this.sort.value;
      }
      if (this.price) {
        url += this.price.value;
      }
      if (this.commerical) {
        url += this.commerical.value;
      }
      if (
        typeof this.keyWord != "undefined" &&
        this.keyWord != null &&
        this.keyWord != ""
      ) {
        url += "&keyword=" + this.keyWord;
      }
      this.setTrackingData(url);
      //console.log("name" + this.motion.title);
      this.$http
        .get(url)
        .then((res) => {
          if (this.keyWord) {
            let order_methods = {
              "": "推荐",
              "&orderBy=2": "最新",
            };
            let choose_prices = {
              "": "全部",
              "&payType=0": "免费",
              "&payType=4": "会员专属",
              "&payType=6": "企业会员专属",
              "&payType=1": "付费",
            };
            sensors.track("classifySearchResult", {
              search_source: "编辑器素材弹窗",
              keyword: this.keyWord,
              has_result: !!(res.data.data && res.data.data.length),
              material_type: "角色",
              search_type: "素材搜索",
              search_result_num: res.data.data.length,
              keyword_type: this.trackingData.keyword_type || "手动输入",
              order_method: this.sort ? order_methods[this.sort.value] : "推荐",
              choose_price: this.price
                ? choose_prices[this.price.value]
                : "全部",
            });
          }
          //this.totalCount = res.data.total;
          if (!this.contentList) {
            this.contentList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }

          if (res.data.total <= this.contentList.length) {
            this.loadingStatus = 2;
          } else {
            this.loadingStatus = 0;
          }
        })
        .catch((res) => {
          //console.log("获取数据失败");
          // this.count = this.contentList.length;
          this.loadingStatus = 0;
        });
    },
    favoriteItem: function (item) {
      let postBody = {
        type: 14,
        id: item.CHARACTER.id,
      };
      if (item.CHARACTER.favorites) {
        postBody.isCancel = 1;
      }
      item.sprite = item.CHARACTER;
      this.trackCollectContent({ ...item, collect_content: "人物" }, postBody);
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
          //请求的返回值中没有带收藏信息
          //所以这里做一个本地的伪处理
          if (item.CHARACTER.favorites) {
            item.CHARACTER.favorites = null;
            this.$bus.emit("favorites.toggle", item, false); //通知右侧列表
          } else {
            item.CHARACTER.favorites = true;
            this.$bus.emit("favorites.toggle", item, true);
          }
        }
      });
    },
    addToCanvas: function (item) {
      this.$bus.emit('beforeAddToCanvas', {data: {...item, characterId: item.CHARACTER.id}, type: 'character'});
      this.trackSearchResultClick(item);
      if (!item.fileType) {
        let fileType = item.url.split(".")[1];
        item.fileType = fileType;
      }
      let soundData = null,
        spriteData = {};
      if (item && item.soundFillType && item.soundUrl) {
        item.fileType = item.soundFillType;
      }

      if (this.SpriteOperation === "swap") {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

        if (sprite.type === "Video") {
          sprite.isLoop = sprite.video.loop;
          sprite.numberOfLoops = sprite.video.repeatTimes;
        }

        spriteData = {
          sprite,
          typeForAdd: "Lottie",
          optionForAdd: {
            lottieOptions: {
              path: this.$handleAssetsUrl(item.url),
              loop: 4,
              autoplay: true, // 控制播放
            },
            resourceId: item.id, // 资源id
            fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
            characterId: item.id, // 选中那个
            isLoop:
              typeof sprite.isLoop === "boolean"
                ? sprite.isLoop
                : sprite.option.isLoop,
            numberOfLoops: sprite.numberOfLoops,
          },
        };
      } else {
        spriteData = {
          lottieOptions: {
            path: this.$handleAssetsUrl(item.url),
            loop: 4,
            autoplay: true, // 控制播放
          },
          resourceId: item.id, // 资源id
          fileType: isNaN(item.fileType) ? null : item.fileType, // 资源type
          characterId: item.id, // 选中那个
          effectCode: "FadeIn",
        };
      }

      if (item && item.soundFillType && item.soundUrl) {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
        soundData = {
          url: item.soundUrl,
          title: item.title,
        };

        if (this.SpriteOperation === "swap") {
          spriteData.optionForAdd.sound = soundData;
          spriteData.optionForAdd.numberOfLoops =
            sprite.numberOfLoops || (sprite.option || {}).numberOfLoops || 3;
          spriteData.optionForAdd.lottieOptions.loop = 3;
        } else {
          spriteData.sound = soundData;
          spriteData.isLoop = true;
          spriteData.numberOfLoops = 3;
          spriteData.lottieOptions.loop = 3;
        }
      }

      if (this.SpriteOperation === "swap") {
        this.TOOL.swapSprite(spriteData, true);
      } else {
        this.TOOL.addSprite("Lottie", spriteData, null, true);
      }

      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    startPreviewItem: function (item, index) {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }

      this.previewTimer = setTimeout(() => {
        let option = {
          container: this.$refs["lottie" + index][0],
          renderer: "svg",
          loop: true,
          autoplay: false,
          path: this.$handleAssetsUrl(item.url),
        };
        this.lottiedata = lottie.loadAnimation(option);
        this.lottiedata.play();
        clearTimeout(this.previewTimer);
      }, 100);
    },
    stopPreviewItem: function () {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }
      if (this.lottiedata) {
        this.lottiedata.stop();
        this.lottiedata.destroy();
        this.lottiedata = null;
      }
    },
    handleScroll(e) {
      if (this.loadingStatus != 0) {
        return;
      }
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pageIndex++;
        this.getContentList();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters([
      "StyleArrayMsg",
      "TOOL",
      "SelectSprites_Msg",
      "SpriteOperation",
      "SpriteBeforeSwap",
      "WorksProjectId",
      "UserMsg",
    ]),
  },
  created() {
    this.sort = this.sortFlags[0];
    this.price = this.priceFlags[0];
    this.commerical = this.commericalFlags[0];

    //this.setStyle(0);
    this.getCharacterAction();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.rootContainer {
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.top-bar-container {
  background-color: #fff;
  min-height: 50px;
  margin: 8px 40px 20px 40px;
  padding: 0;
  flex-shrink: 0;
}

.fixed-filter-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20px;
  /* margin-top: 10px; */
}

.fixed-filter-container .fixedFilter {
  margin-left: 29px;
}

.fixed-filter-container /deep/ .list-container {
  margin-left: 10px;
}

.fixed-filter-container /deep/ .list li {
  padding: 0 10px;
}

.content-container {
  /* height: 495px; */
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}

.content-list {
  padding: 22px 0px 0px 39px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /* overflow-y: auto; */
  /* height: 495px; */
  width: 100%;
  flex-grow: 1;
}
.loading {
  position: relative;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
  //line-height: 110px;

  &>div{
    height:30px;
    line-height: 30px;
    align-self: start;
  }
}

.content-list li {
  transition: all 0.4s;
}

.content-list-li-layout {
  position: relative;
  width: 140px;
  height: 172px;
  margin-right: 25px;
  margin-bottom: 19px;
  box-sizing: border-box;
}
.action-name {
  position: absolute;
  text-align: left;
  font-size: 12px;
  color: #474261;
  margin-top: 10px;
  left: 0;
}

.bg {
  width: 140px;
  height: 140px;
  position: relative;
  background-color: #fff;
  border-radius: 6px;
  border: solid 1px #f0f0f8;
}

.static-cover {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: auto;
  transform: translate(-50%, 0);
}

.lottie-cover {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}

/* .content-list li:nth-child(6n) {
  margin-right: 0px;
} */

.content-list li:hover {
  transform: scale(1.14);
}

.content-list li:hover .lottie-cover {
  display: block;
}

.content-list li:hover .addbtn {
  opacity: 1;
}

.content-list li:hover .price-style {
  opacity: 0;
}

.content-list li:hover .logo-container {
  opacity: 0;
}

.content-list li:hover .favorites-bg {
  display: block;
  animation: favorites-fadein 0.4s;
}

.content-list li:hover .action-name {
  opacity: 0;
  transition: all 0.2s ease-in-out;
}

.addbtn {
  position: absolute;
  display: block;
  width: 88px;
  height: 28px;
  background-color: #5778fb;
  border-radius: 13px;
  left: 4px;
  bottom: 4px;

  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;

  opacity: 0;
  transition: all 0.4s;
}

.price-style {
  position: absolute;
  bottom: 4px;
  right: 4px;
  /* width: 72px; */
  height: 18px;
  padding: 0 6px;
  color: #ffffff;
  font-size: 12px;
  background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
  border-radius: 4px;
  text-align: center;

  transition: all 0.4s;
}

.logo-container {
  position: absolute;

  right: 0;
  display: flex;
  justify-content: flex-end;

  transition: all 0.4s;
}

.commerical-logo {
  width: 20px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/commerical.svg);
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 5px;
}

.vip-logo {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 64px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/vip-exclusive.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

@keyframes favorites-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.7;
  }
}

.favorites-bg {
  position: absolute;
  display: none;
  width: 24px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  right: 4px;
  top: 4px;

  opacity: 0.7;
  /* transition: all 0.4s; */
}

.favorites-bg:hover {
  opacity: 1;
}

.favorites-state {
  width: 12px;
  height: 12px;
  margin-top: 4px;
  margin-left: 6px;
}
.already-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/already-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.no-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/no-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.style-layout {
  margin-left: 39px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/rolesContent.vue